import { render, staticRenderFns } from "./DarkModeDialog.vue?vue&type=template&id=112b6b12&scoped=true"
import script from "./DarkModeDialog.vue?vue&type=script&lang=js"
export * from "./DarkModeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112b6b12",
  null
  
)

export default component.exports